import React, { useState, useEffect, useMemo } from "react"
import "../../Styles/Menu.css"
import UsefetchCollectionNonRealtime from "../Componentslogic/UsefetchcollectionNonrealtime"
import { motion as m } from "framer-motion"
import IMG from "../images/Frame 73.png"
import { Link } from "react-router-dom"
import CartIcon from "../images/Cart_I.svg"
import SearchIcon from "../images/Search.svg"
import { SelectFilteredproducts } from "../../redux/actions/FilterProducts"
import { useSelector, useDispatch } from "react-redux"
import { selectCartitems } from "../../redux/actions/CartSlice"
import { ADD_TO_CART } from "../../redux/actions/CartSlice"
import Notify from "../Componentslogic/Usenotifications"
import Modal from "react-modal"
import { collection, getDocs, query, where } from "firebase/firestore"
import { db } from "../../Firebase/config"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
// Set root for accessibility (only needed once in the app)
Modal.setAppElement("#root")
const MenuMain = () => {
  const dispatch = useDispatch()
  const cartData = useSelector(selectCartitems)
  // State for selected sizes of products
  const [selectedSizes, setSelectedSizes] = useState({})
  const { data: Categories } = UsefetchCollectionNonRealtime(
    "Categories",
    "asc",
  )
  const { data: Products } = UsefetchCollectionNonRealtime("Products")

  // State for the active category

  const [selectedCombos, setSelectedCombos] = useState({}) // 🔥 Store combos per product
  const [activeCategory, setActiveCategory] = useState(null)
  const [imageCache, setImageCache] = useState({})
  const [showModal, setShowModal] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [selectedSpiceLevels, setSelectedSpiceLevels] = useState({})
  const [spicePrice, setSpicePrice] = useState(0)
  const [bestSellerProducts, setBestSellerProducts] = useState([])
  const [showSauceSelectionModal, setShowSauceSelectionModal] = useState(false)
  const [showSaucesModal, setShowSaucesModal] = useState(false)
  const [showOfferModal, setShowOfferModal] = useState(false)
  const [selectedOfferIndex, setSelectedOfferIndex] = useState(0)
  const [Offers, setOffers] = useState([])
  const [sauces, setSauces] = useState([])
  const [selectedSauces, setSelectedSauces] = useState({})
  const [selectedFreeSauces, setSelectedFreeSauces] = useState({})
  const [language, setLanguage] = useState("en")

  const selectedProductId =
    selectedProduct?.id || Object.keys(selectedFreeSauces)[0]

  const selectedCount =
    selectedFreeSauces[selectedProductId]?.names?.length || 0
  const requiredCount =
    Products.find((p) => p.id === selectedProductId)?.noOfSauces || 1

  const validCategories = ["Nashville", "Meals", "Appetizers"]

  const handleSauceSelection = (productId, sauce) => {
    const product = selectedProduct
    const limit = product?.noOfSauces || 1

    setSelectedFreeSauces((prev) => {
      const current = prev[productId]?.names || []

      const isAlreadySelected = current.includes(sauce.name)
      let updated

      if (isAlreadySelected) {
        // Unselect if already selected
        updated = current.filter((s) => s !== sauce.name)
      } else {
        if (limit === 1) {
          // 🔥 Replace the selection if limit is 1
          updated = [sauce.name]
        } else {
          // 🔥 For multiple selections, limit addition
          if (current.length >= limit) return prev
          updated = [...current, sauce.name]
        }
      }

      return {
        ...prev,
        [productId]: { names: updated },
      }
    })
  }

  const isComboEligible = (product) => {
    return (
      product?.CategoryName === "Smash Burger" ||
      product?.CategoryName === "Nashville"
    )
  }

  const [showComboModal, setShowComboModal] = useState(false)
  const [comboProducts, setComboProducts] = useState([])
  const [searchQuery, setSearchQuery] = useState("")
  const [showSearchBar, setShowSearchBar] = useState(false)

  const toggleSearchBar = () => {
    setShowSearchBar(!showSearchBar)
    setSearchQuery("") // Clear search when toggling
  }

  const handleSauceSizeSelect = (sauceId, sizeOption) => {
    setSelectedSauces((prev) => ({
      ...prev,
      [sauceId]: sizeOption,
    }))
  }

  const handleAddSauce = (sauce) => {
    const selectedSize = selectedSauces[sauce.id]

    if (!selectedSize) {
      Notify(`Please select a size for ${sauce.name}`, "error")
      return
    }

    const sauceItem = {
      ...sauce,
      selectedSize: selectedSize.size,
      Price: selectedSize.Price,
      uniqueKey: `sauce-${sauce.id}-${selectedSize.size}`,
    }

    dispatch(ADD_TO_CART(sauceItem))
    Notify(`${sauce.name} (${selectedSize.size}) added to cart`, "success")
  }

  const toggleLanguage = () => {
    setLanguage((prevLang) => (prevLang === "en" ? "ar" : "en"))
  }

  useEffect(() => {
    const fetchComboProducts = async () => {
      try {
        const comboQuery = query(
          collection(db, "Products"),
          where("CategoryName", "==", "Combo"),
        )
        const comboSnapshot = await getDocs(comboQuery)
        const comboList = comboSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        comboList.sort((a, b) => {
          if (a.order === undefined) return 1
          if (b.order === undefined) return -1
          return a.order - b.order
        })

        setComboProducts(comboList)
      } catch (error) {
        console.error("Error fetching combo products:", error)
      }
    }

    fetchComboProducts()
  }, [])

  const confirmMealWithSauce = () => {
    if (!selectedProduct) return
    setShowSauceSelectionModal(false) // Close Sauce Selection Modal
    setShowModal(true) // Open Spice Selection Modal
  }
  const handleAddCombo = (productId, combo) => {
    setSelectedCombos((prev) => ({
      ...prev,
      [productId]: combo, // 🔥 Save combo specifically for this product
    }))
    Notify(`${combo.name} selected for ${selectedProduct.name}`, "success")
    setShowComboModal(false)
  }

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "Offers"))
        const offersList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))

        setOffers(offersList)

        // ✅ **Show Modal if Offers exist and user hasn't seen it**
        if (offersList.length > 0 && !localStorage.getItem("seenOffer")) {
          setTimeout(() => setShowOfferModal(true), 300) // Delay to allow state update
        }
      } catch (error) {
        console.error("Error fetching offers:", error)
      }
    }

    fetchOffers()
  }, [])

  const handleSpiceLevelChange = (productId, level) => {
    setSelectedSpiceLevels((prev) => ({
      ...prev,
      [productId]: level, // ✅ Store spice level for specific product
    }))
    setSpicePrice(level === "Spicy 3" ? 5 : 0)
  }

  useEffect(() => {
    const fetchSauces = async () => {
      try {
        const saucesQuery = query(
          collection(db, "Products"),
          where("CategoryName", "==", "Sauces"), // ✅ Fetch only products under "Sauces" category
        )

        const saucesSnapshot = await getDocs(saucesQuery)
        const saucesList = saucesSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))

        setSauces(saucesList)
      } catch (error) {
        console.error("Error fetching sauces:", error)
      }
    }

    fetchSauces()
  }, [])

  const handleOfferAction = () => {
    setShowOfferModal(false)
    localStorage.setItem("seenOffer", "true") // Save state to local storage
  }
  const offerSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    afterChange: (index) => setSelectedOfferIndex(index),
    appendDots: (dots) => (
      <div style={{ position: "absolute", bottom: "-40px", width: "100%" }}>
        <ul style={{ display: "flex", justifyContent: "center", padding: 0 }}>
          {dots.map((dot, index) => (
            <li key={index} style={{ margin: "0 5px", listStyle: "none" }}>
              <button
                style={{
                  background:
                    index === selectedOfferIndex
                      ? "#ffcc00"
                      : "rgba(255,255,255,0.3)",
                  color: "#000",
                  fontWeight: "bold",
                  borderRadius: "50%",
                  width: "10px",
                  height: "10px",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={() => setSelectedOfferIndex(index)}
              >
                {index + 1}
              </button>
            </li>
          ))}
        </ul>
      </div>
    ),
  }

  useEffect(() => {
    const fetchBestSellers = async () => {
      try {
        const ordersSnapshot = await getDocs(collection(db, "Orders"))
        const productCounts = {}

        ordersSnapshot.forEach((doc) => {
          const orderData = doc.data()
          orderData.cartItems.forEach((item) => {
            if (!productCounts[item.name]) {
              productCounts[item.name] = 0
            }
            productCounts[item.name] += item.CartTotalQuantity
          })
        })

        // 🔥 Sort and get top 3 best sellers
        const sortedBestSellers = Object.entries(productCounts)
          .sort((a, b) => b[1] - a[1])
          .slice(0, 3) // Get top 3

        // 🔥 Find product details from Products collection
        const bestSellers = sortedBestSellers
          .map(([name]) => Products.find((product) => product.name === name))
          .filter(Boolean)

        setBestSellerProducts(bestSellers)
      } catch (error) {
        console.error("Error fetching best sellers:", error)
      }
    }

    if (Products.length > 0) {
      fetchBestSellers()
    }
  }, [Products])
  const dynamicCategories = useMemo(() => {
    const sortedCategories = [...Categories]
      .filter((category) => category.name !== "Combo")
      .sort((a, b) => {
        const aHasOrder = typeof a.order === "number"
        const bHasOrder = typeof b.order === "number"

        if (aHasOrder && bHasOrder) {
          return a.order - b.order
        }

        if (aHasOrder && !bHasOrder) return -1
        if (!aHasOrder && bHasOrder) return 1

        return 0
      })

    return [
      ...(bestSellerProducts.length > 0
        ? [{ id: "best-seller", name: "Best Seller", order: -1 }]
        : []),
      ...sortedCategories,
    ]
  }, [Categories, bestSellerProducts])

  useEffect(() => {
    if (Products.length > 0) {
      const defaultSizes = {}
      Products.forEach((product) => {
        if (product.sizes && product.sizes.length > 0) {
          defaultSizes[product.id] = product.sizes[0]
        }
      })
      setSelectedSizes(defaultSizes)
    }
  }, [Products])

  useEffect(() => {
    if (dynamicCategories.length === 0) return

    const activeStillExists = dynamicCategories.some(
      (category) => category.id === activeCategory,
    )

    if (!activeCategory || !activeStillExists) {
      setActiveCategory(dynamicCategories[0].id)
    }
  }, [dynamicCategories, activeCategory])

  const [imageLoaded, setImageLoaded] = useState({})

  useEffect(() => {
    setImageLoaded((prev) => ({ ...prev }))
  }, [activeCategory])

  const handleImageLoad = (productId) => {
    setImageLoaded((prev) => ({
      ...prev,
      [productId]: true,
    }))
  }

  const confirmSpiceLevel = () => {
    if (!selectedProduct) return

    let selectedSize = null
    let itemToAdd

    if (selectedProduct.sizes && selectedProduct.sizes.length > 0) {
      selectedSize =
        selectedSizes[selectedProduct.id] || selectedProduct.sizes[0]
    }
    const isSpiceRequired =
      validCategories.includes(selectedProduct?.CategoryName) ||
      selectedProduct?.name === "Nash Fries"

    const selectedSpice = selectedSpiceLevels[selectedProduct?.id]

    if (isSpiceRequired && !selectedSpice) {
      Notify("Please select a spice level.", "error")
      return
    }

    const spiceCharge = selectedSpice === "Spicy 3" ? 5 : 0

    const basePrice = selectedSize ? selectedSize.Price : selectedProduct.Price
    const finalPrice = basePrice + spiceCharge

    itemToAdd = {
      ...selectedProduct,
      selectedSize: selectedSize ? selectedSize.size : null,
      Price: finalPrice,
      freeSauce:
        selectedFreeSauces[selectedProduct?.id]?.names?.join(" & ") || null,

      spiceLevel:
        selectedProduct.CategoryName === "Smash Burger"
          ? null
          : selectedSpiceLevels[selectedProduct?.id] || "Spicy 1",

      combo: selectedCombos[selectedProduct.id] || null,
      uniqueKey: `${selectedProduct.id}-${selectedSize?.size || "default"}-${
        selectedProduct.CategoryName === "Smash Burger"
          ? "NoSpice"
          : selectedSpiceLevels[selectedProduct?.id]
      }-${selectedCombos[selectedProduct.id]?.id || "NoCombo"}`,
    }
    dispatch(ADD_TO_CART(itemToAdd))
    Notify("Added to cart", "success")
    setShowModal(false)
    setSelectedSpiceLevels({})
    setSpicePrice(0)
    setSelectedCombos({})
    setSelectedFreeSauces({})
    setSelectedProduct(null)
  }

  const handleAddToCart = (product, isOffer = false) => {
    if (
      product.CategoryName === "Meals" ||
      product.CategoryName === "Wings" ||
      product.CategoryName === "Appetizers"
    ) {
      setSelectedProduct(product)
      setShowSauceSelectionModal(true)
      return
    }

    // ✅ If it's a sauce, make sure size is selected before adding to cart
    if (product.CategoryName === "Sauces") {
      const selectedSize =
        selectedSauces[product.id] || (product.sizes ? product.sizes[0] : null)

      if (!selectedSize) {
        Notify(`Please select a size for ${product.name}`, "error")
        return
      }

      const sauceItem = {
        ...product,
        selectedSize: selectedSize.size,
        Price: selectedSize.Price,
        uniqueKey: `sauce-${product.id}-${selectedSize.size}`,
      }

      dispatch(ADD_TO_CART(sauceItem))
      Notify(`${product.name} (${selectedSize.size}) added to cart`, "success")
      return
    }

    if (isOffer || product.CategoryName === "Drinks") {
      const itemToAdd = {
        ...product,
        uniqueKey: `quick-${product.id}`,
      }

      dispatch(ADD_TO_CART(itemToAdd))
      Notify(`${product.name} added to cart`, "success")
      return
    } else {
      setSelectedProduct(product)
      setShowModal(true)
    }
  }

  const handleShowOffers = () => {
    setShowOfferModal(true)
  }

  const handleSizeChange = (productId, size) => {
    setSelectedSizes((prev) => ({
      ...prev,
      [productId]: size,
    }))
  }
  const filteredProducts = Products?.filter((product) => {
    const matchesCategory =
      activeCategory === "best-seller"
        ? bestSellerProducts.includes(product)
        : product.CategoryId === activeCategory

    const matchesSearch = product.name
      .toLowerCase()
      .includes(searchQuery.toLowerCase())

    return matchesCategory && matchesSearch
  })?.sort((a, b) => {
    const aOrder = a.order ?? Number.MAX_SAFE_INTEGER
    const bOrder = b.order ?? Number.MAX_SAFE_INTEGER
    return aOrder - bOrder
  })

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const handleCloseModalShow = () => {
    setShowModal(false)

    // 🔥 Reset all selections
    setSelectedSpiceLevels({})
    setSpicePrice(0)
    setSelectedCombos({})
    setSelectedFreeSauces({})
    setSelectedProduct(null)
  }

  return (
    <>
      <div className="menu-container">
        <header className="app-header d-flex flex-column">
          <h4 className="fw-bold mb-1">A TASTE YOU CAN SEE 🔥</h4>
          <div className="language-toggle-container ">
            <div
              className={`language-switch mt-2 mb-2 ${
                language === "ar" ? "ar" : ""
              }`}
              onClick={toggleLanguage}
            >
              <span>{language === "en" ? "ع" : "EN"}</span>
              <div className="switch-circle"></div>
              <span>{language === "en" ? "ع" : "E"}</span>
            </div>
          </div>
        </header>

        {showSearchBar && (
          <div className="search-bar-container">
            <input
              type="text"
              className="search-input"
              placeholder="Search for products..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoFocus
            />
          </div>
        )}

        {Offers.length > 0 && (
          <div className="d-flex justify-content-center mb-3">
            <button className="btns-Offer" onClick={handleShowOffers}>
              View Offers
            </button>
          </div>
        )}

        <div className="Categories-title">
          {language === "en" ? "Categories" : "الفئات"}
        </div>
        {/* Dynamic Categories */}
        <div className="categories">
          {dynamicCategories.map((category, index) => (
            <m.div
              key={category.id}
              className={`category ${
                activeCategory === category.id ? "active" : ""
              }`}
              onClick={() => setActiveCategory(category.id)}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.3 }}
            >
              <p className="p-0 m-0 Text-mon" style={{ textAlign: "center" }}>
                {category.name}
              </p>
            </m.div>
          ))}
        </div>

        <div className="Products-List">
          {/* Dynamic Products */}
          {filteredProducts?.map((product, index) => (
            <div>
              <m.div
                key={product.id}
                className="product-card "
                initial={{ opacity: 0, x: 15 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.5 }}
              >
                {product.imageUrl && (
                  <div className="d-flex ">
                    <div className="image-container">
                      <img
                        className={`products-images ${
                          imageLoaded[product.id] ? "fade-in" : "hidden"
                        }`}
                        src={imageCache[product.id] || product.imageUrl}
                        onLoad={() => {
                          setImageLoaded((prev) => ({
                            ...prev,
                            [product.id]: true,
                          }))
                          setImageCache((prev) => ({
                            ...prev,
                            [product.id]: product.imageUrl,
                          }))
                        }}
                        onError={() =>
                          console.log("Image failed to load", product.imageUrl)
                        }
                      />
                    </div>
                  </div>
                )}
                <div>
                  <h2 className="product-name">
                    {" "}
                    {language === "en"
                      ? product.name
                      : product.ProductNameArabic}
                  </h2>
                  <p className="product-description">
                    {" "}
                    {language === "en"
                      ? product.description
                      : product.DescriptionArabic}
                  </p>
                  {product.sizes && product.sizes.length > 0 && (
                    <div className="size-options">
                      {product.sizes.map((size, i) => (
                        <button
                          key={i}
                          className={`size-button ${
                            selectedSizes[product.id]?.size === size.size
                              ? "active"
                              : ""
                          }`}
                          onClick={() => handleSizeChange(product.id, size)}
                        >
                          {size.size}
                        </button>
                      ))}
                    </div>
                  )}
                  <h2 className="product-price">
                    Price:{" "}
                    {(selectedSizes[product.id]?.Price || product.Price) +
                      (selectedSpiceLevels[product.id] === "Spicy 3"
                        ? 5
                        : 0)}{" "}
                    EGP
                  </h2>
                </div>
              </m.div>

              <div className="horizontal-line"> </div>
            </div>
          ))}
        </div>
      </div>
      {/* 
      <m.div
        className="Cart-search"
        initial={{ opacity: 0, y: 0 }}
        animate={{ opacity: 1, y: -15 }}
        transition={{ duration: 0.5, delay: 1 }}
      >
        <div className="Cart-searchbg">
          <Link to="/Orderreview">
            <div className="position-relative">
              <img src={CartIcon} alt="Cart-icon "></img>
              <span className="red-circle-Cart">
                <p className="p-0 m-0  ">
                  <b>{cartData.length}</b>
                </p>
              </span>
            </div>
          </Link>
          <img
            src={SearchIcon}
            alt="Search-icon"
            className="search-icon"
            onClick={toggleSearchBar} // Toggle search bar on click
          />
        </div>
      </m.div> */}

      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        className="spice-modal"
        overlayClassName="spice-overlay"
      >
        {validCategories.includes(selectedProduct?.CategoryName) ||
        selectedProduct?.name === "Nash Fries" ? (
          <>
            <h2 className="modal-title">Select Spice Level 🌶️</h2>
            <div className="spice-options">
              {["Spicy 1", "Spicy 2", "Spicy 3"].map((level) => (
                <button
                  key={level}
                  className={`spice-button ${
                    selectedSpiceLevels[selectedProduct?.id] === level
                      ? "active"
                      : ""
                  }`}
                  onClick={() =>
                    handleSpiceLevelChange(selectedProduct?.id, level)
                  }
                >
                  {level}{" "}
                  {level === "Spicy 3" && (
                    <span className="fw-normal " style={{ fontSize: "14px" }}>
                      {" "}
                      (+5 EG)
                    </span>
                  )}
                </button>
              ))}
            </div>
          </>
        ) : null}
        {isComboEligible(selectedProduct) && (
          <>
            {selectedCombos[selectedProduct?.id] ? ( // ✅ Check for specific product combo
              <div className="combo-selected">
                <h3 className="modal-subtitle">
                  {language === "ar" ? "تم اختيار الكومبو:" : "Combo Chosen:"}
                </h3>
                <p className="combo-info">
                  {language === "ar"
                    ? selectedCombos[selectedProduct?.id].ProductNameArabic
                    : selectedCombos[selectedProduct?.id].name}{" "}
                  - {selectedCombos[selectedProduct?.id].Price} EGP
                </p>
                <div className="combo-actions mb-4">
                  <button
                    className="combo-button mx-2 p-2"
                    onClick={() => setShowComboModal(true)}
                  >
                    {language === "ar" ? "تعديل الكومبو" : "Edit Combo"}
                  </button>
                  <button
                    className="combo-button p-2"
                    onClick={() => {
                      setSelectedCombos((prev) => ({
                        ...prev,
                        [selectedProduct?.id]: null, // ✅ Remove combo only for this product
                      }))
                      Notify(
                        language === "ar"
                          ? "تم إزالة الكومبو"
                          : "Combo removed",
                        "success",
                      )
                    }}
                  >
                    {language === "ar" ? "إزالة الكومبو" : "Remove Combo"}
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <h3 className="modal-subtitle">
                  {language === "ar"
                    ? "هل ترغب في إضافة كومبو؟"
                    : "Would You Like a Combo?"}
                </h3>
                <button
                  className="confirm-button mb-4"
                  onClick={() => setShowComboModal(true)}
                >
                  Select Combo
                </button>
              </div>
            )}
          </>
        )}

        <button
          className="confirm-button mb-4"
          onClick={() => setShowSaucesModal(true)}
        >
          Add Sauces?
        </button>
        <div>
          <button className="confirm-button" onClick={confirmSpiceLevel}>
            Confirm
          </button>
          <button
            className="close-button"
            onClick={() => handleCloseModalShow()}
          >
            Cancel
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={showSaucesModal}
        onRequestClose={() => setShowSaucesModal(false)}
        className="sauces-modal"
      >
        <h2 className="sauces-modal-title">
          {language === "ar" ? "اختر الصوص الخاص بك" : "Choose Your Sauces"}
        </h2>

        <div className="sauces-modal-list">
          {sauces.map((sauce) => (
            <div key={sauce.id} className="sauces-modal-item">
              {/* Sauce Name in a Full-Width Row */}
              <p className="sauces-modal-name">
                {language === "ar" ? sauce.ProductNameArabic : sauce.name}
              </p>

              {/* Size Selection in a Row */}
              <div className="sauces-modal-sizes">
                {sauce.sizes.map((sizeOption, index) => (
                  <label key={index} className="sauces-modal-size-label">
                    <input
                      type="radio"
                      name={`sauce-${sauce.id}`}
                      value={sizeOption.size}
                      onChange={() =>
                        handleSauceSizeSelect(sauce.id, sizeOption)
                      }
                    />
                    {sizeOption.size} - {sizeOption.Price} EGP
                  </label>
                ))}
              </div>

              {/* Add Button in a New Row */}
              <div className="sauces-modal-action">
                {/* <button
                  className="sauces-modal-add-button"
                  onClick={() => handleAddSauce(sauce)}
                >
                  +
                </button> */}
              </div>
            </div>
          ))}
        </div>

        <button
          className="sauces-modal-close-button"
          onClick={() => setShowSaucesModal(false)}
        >
          {language === "ar" ? "تم" : "Done"}
        </button>
      </Modal>

      <Modal
        isOpen={showOfferModal}
        onRequestClose={handleOfferAction}
        contentLabel="Exclusive Offers"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100dvh",
          },
          content: {
            position: "relative",
            inset: "unset",
            width: "90%",
            maxWidth: "420px",
            padding: "20px",
            borderRadius: "16px",
            textAlign: "center",
            background: "linear-gradient(180deg, #ab2421 30%, #f4480a 100%)",
            boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.15)",
            border: "1px solid #ddd",
          },
        }}
      >
        {Offers.length > 1 ? (
          <Slider {...offerSettings}>
            {Offers.map((offer, index) => (
              <div key={index} className="offer-modal">
                <img src={offer.imageUrl} alt="Offer" />
                <h2 className="offer-title">{offer.name}</h2>
                <p className="offer-description">{offer.description}</p>
                <h3 className="offer-price">Price: {offer.Price} EGP</h3>
                <div className="offer-buttons">
                  {/* <button
                    className="add-to-cart-button"
                    onClick={() => handleAddToCart(offer, true)}
                  >
                    Add To Cart
                  </button> */}
                  <button
                    className="continue-button"
                    onClick={handleOfferAction}
                  >
                    Continue to Menu
                  </button>
                </div>
              </div>
            ))}
          </Slider>
        ) : Offers.length === 1 ? (
          <div className="offer-modal">
            <img src={Offers[0].imageUrl} alt="Offer" />
            <h2 className="offer-title">{Offers[0].name}</h2>
            <p className="offer-description">{Offers[0].description}</p>
            <h3 className="offer-price">Price: {Offers[0].Price} EGP</h3>
            <div className="offer-buttons">
              {/* <button
                className="add-to-cart-button"
                onClick={() => {
                  handleAddToCart(Offers[0], true)
                  setShowOfferModal(false)
                }}
              >
                Add To Cart
              </button> */}
              <button className="continue-button" onClick={handleOfferAction}>
                Continue to Menu
              </button>
            </div>
          </div>
        ) : null}
      </Modal>

      <Modal
        isOpen={showComboModal}
        onRequestClose={() => setShowComboModal(false)}
        className="Combos-modal"
      >
        <h2 className="modal-title">
          {language === "ar" ? "اختر وجبتك" : "Choose Your Combo"}
        </h2>

        <div className="combo-list">
          {comboProducts.map((combo) => (
            <div
              key={combo.id}
              className="d-flex justify-content-between align-items-center"
            >
              <p className="p-0 mb-3">
                {language === "ar" ? combo.ProductNameArabic : combo.name} -{" "}
                {combo.Price}
              </p>
              {/* <button
                className="combo-button mx-2 mb-3 p-1"
                onClick={() => handleAddCombo(selectedProduct.id, combo)}
              >
                +
              </button> */}
            </div>
          ))}
        </div>

        <button
          className="close-button"
          onClick={() => setShowComboModal(false)}
        >
          {language === "ar" ? "إلغاء" : "Cancel"}
        </button>
      </Modal>

      <Modal
        isOpen={showSauceSelectionModal}
        onRequestClose={() => setShowSauceSelectionModal(false)}
        className="sauces-modal"
      >
        <h2 className="sauce-selection-title">
          {language === "ar"
            ? "اختر الصوص المجاني الخاص بك"
            : "Choose Your Free Sauce"}
        </h2>
        <p className="free-sauce-info">
          {language === "ar"
            ? `برجاء اختيار ${requiredCount} صوص مجانا لهذا المنتج.`
            : `Please select ${requiredCount} free sauce${
                requiredCount > 1 ? "s" : ""
              } for this item.`}
        </p>

        <div className="sauces-modal-list">
          {sauces
            .filter(
              (sauce) =>
                !["Cheese cup XL", "Cheese Cup Sauce"].includes(sauce.name),
            )
            .map((sauce) => (
              <div
                key={sauce.id}
                className={`sauce-item ${
                  selectedFreeSauces[selectedProduct?.id]?.names?.includes(
                    sauce.name,
                  )
                    ? "selected"
                    : ""
                }`}
                onClick={() => handleSauceSelection(selectedProduct?.id, sauce)}
                style={{
                  color: selectedFreeSauces[
                    selectedProduct?.id
                  ]?.names?.includes(sauce.name)
                    ? "#fff"
                    : " #000",
                  padding: "10px",
                  border: selectedFreeSauces[
                    selectedProduct?.id
                  ]?.names?.includes(sauce.name)
                    ? "2px solid #f4480a"
                    : "1px solid #ccc",
                  background: selectedFreeSauces[
                    selectedProduct?.id
                  ]?.names?.includes(sauce.name)
                    ? "#f4480a"
                    : "white",
                  borderRadius: "8px",
                  marginBottom: "5px",
                }}
              >
                <p className="sauce-name">{sauce.name}</p>
              </div>
            ))}
        </div>
        {selectedFreeSauces[selectedProduct?.id]?.names?.length > 0 && (
          <p className="selected-sauce">
            Selected Sauce(s):{" "}
            <strong>
              {selectedFreeSauces[selectedProduct?.id].names.join(" & ")}
            </strong>
          </p>
        )}
        <button
          className="confirm-button"
          onClick={confirmMealWithSauce}
          disabled={selectedCount !== requiredCount}
          style={{
            backgroundColor:
              selectedCount === requiredCount ? "#f4480a" : "#ccc",
            color: selectedCount === requiredCount ? "#fff" : "#888",
            cursor: selectedCount === requiredCount ? "pointer" : "not-allowed",
          }}
        >
          {language === "ar" ? "التالي" : "Next"}
        </button>
      </Modal>
    </>
  )
}

export default MenuMain
